import { IReportPermissions } from "src/pages/Reports/models/interface";
import { IAuthorData } from "src/pages/Studies/models/interfaces";

export interface ISubHeaderProps {
	title: string;
	subtitle?: string | React.ReactNode;
	type?: string;
	tags: string[];
	buttons?: React.ReactNode[];
	onTagSelect?: (tag: string) => void;
	permissions?: IReportPermissions;
	updatedBy?: string;
	createdBy?: IAuthorData;
	secondStep?: string;
	secondStepTitle?: string;
	handleClose?: () => void;
	renderedFrom?: ModuleType;
	reportIterationId?: string;
	handleManualSave?: () => void;
}

export enum ModuleType {
	Reports = "Reports",
	ViewReports = "ViewReports",
	Studies = "Studies",
	Segments = "Segments",
	DTProjects = "DTProjects",
	PersonaProjects = "PersonaProjects",
}
